// src/pages/treatments/CrownsAndBridges.jsx
import { Link } from 'react-router-dom';
import CBT5 from '../../Assets/Services/C&BT5.webp'
import CB from '../../Assets/Services/C&B.webp'
const CrownsAndBridges = () => {
  return (
    <main className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-80 md:h-[500px] flex items-center justify-center bg-blue-50">
        <div className="absolute inset-0">
          <img
            src={CBT5}
            alt="Crowns & Bridges"
            className="w-full h-full object-cover brightness-75"
          />
          {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
          {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Crowns & Bridges
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light">
            Restore your smile with durable crowns and bridges
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      {/* <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4 flex flex-wrap items-center text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <span className="mx-2">›</span>
          <Link to="/treatments" className="hover:text-blue-600 transition">Treatments</Link>
          <span className="mx-2">›</span>
          <span className="text-blue-600 font-medium">Crowns & Bridges</span>
        </div>
      </div> */}

      {/* Main Content – Flex Layout */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Image Section */}
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={CB}
                alt="Crowns & Bridges Procedure"
                className="w-full max-w-md rounded-2xl shadow-xl object-cover"
              />
            </div>

            {/* Text Content */}
            <div className="w-full lg:w-1/2 flex flex-col">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Crowns and Bridges Treatment
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Crowns and bridges dental treatment use prosthetic devices to get back your smile. These are not removable as they are cemented onto the teeth and can be removed only by a dental specialist. Apart from strengthening a damaged tooth, a crown is as well used to shape, align and improve the appearance of your teeth. Bridges on the other hand are recommended if you’re missing more than one tooth. They are used to replace a missing tooth or teeth as they cemented to the natural teeth or implants surrounding the empty space. The crowns and bridges last for a lifetime.
              </p>

              {/* CTA */}
              <div className="flex justify-start">
                <Link to="/book-appointment" className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition">
                  Book Appointment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CrownsAndBridges;